import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { eventHub } from '../../pm-plugins/ai-event-hub/event-hub';
import { findEditorIdFromView } from '../../pm-plugins/ai-event-hub/utils/isolated-utils';
import type { RelatedResourceRetrieval } from '../../types/types';
import type { EditorPluginAIConfigItem } from '../prebuilt/config-items/config-items';

/**
 * Publishes 'ai experience llm complete' event when an AI experience stream completes.
 * Products can subscribe to this event to handle product-specific logic (e.g. draft reply evaluation)
 * without platform needing product-specific code.
 */
/**
 * Currently implmented for internal use by JSM ASAP AI team
 * Reach out to #jsm-cloud-asap-ai on Slack for help
 */
export const publishAiExperienceLlmComplete = (
	configItem: EditorPluginAIConfigItem,
	markdown: string,
	editorView: EditorView,
	analyticSourceId: string,
	relatedResourceRetrievals?: RelatedResourceRetrieval[],
): void => {
	const sourceEditorId = findEditorIdFromView(editorView);
	if (!sourceEditorId) {
		return;
	}

	eventHub.publishFromEditor({
		event: 'ai experience llm complete',
		data: {
			analyticSourceId,
			configItemKey: configItem.key,
			markdown,
			sourceEditorId,
			...(relatedResourceRetrievals &&
				fg('jira_improve_description_related_resources_metadata') && {
					relatedResourceRetrievals,
				}),
			...(configItem.draftReplyMetadata && {
				draftReplyMetadata: configItem.draftReplyMetadata,
			}),
		},
	});
};
